import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
    AuthGuard,
    redirectLoggedInTo,
    redirectUnauthorizedTo,
} from '@angular/fire/auth-guard';
import { WelcomeComponent } from './pages/welcome/welcome.component';
import { HomeComponent } from './pages/home/home.component';
import { DocumentsComponent } from './pages/documents/documents.component';
import { AuthorsComponent } from './pages/authors/authors.component';


const redirectUnauthorizedToWelcome = () => redirectUnauthorizedTo(['welcome']);
const redirectLoggedInToHome = () => redirectLoggedInTo(['home']);


export const routes: Routes = [
    {
        path: 'welcome',
        component: WelcomeComponent,
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectLoggedInToHome }
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectUnauthorizedToWelcome }
    },
    {
        path: 'documents',
        component: DocumentsComponent,
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectUnauthorizedToWelcome }
    },
    {
        path: 'authors',
        component: AuthorsComponent,
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectUnauthorizedToWelcome }
    },
    {
        path: '**',
        component: WelcomeComponent
    }
];


@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }

